import { createPageMeta } from '@/config/gbwaps';
import { withTrailingSlash } from '@/utils/route-path';
import {
	SOFTWARE_APPLICATION_SCHEMA,
	FAQ_PAGE_SCHEMA,
} from '@/data/home-content';
import Home from '@/views/gbwaps/Home.vue';
import Download from '@/views/gbwaps/Download.vue';
import InstallGbwhatsapp from '@/views/gbwaps/InstallGbwhatsapp.vue';
import PagePlaceholder from '@/views/gbwaps/PagePlaceholder.vue';
import { INSTALL_HOWTO_SCHEMA } from '@/data/install-content';
import { UPDATE_HOWTO_SCHEMA } from '@/data/update-content';
import GbwhatsappUpdate from '@/views/gbwaps/GbwhatsappUpdate.vue';
import Features from '@/views/gbwaps/Features.vue';
import AntiBan from '@/views/gbwaps/AntiBan.vue';
import Faq from '@/views/gbwaps/Faq.vue';
import Troubleshooting from '@/views/gbwaps/Troubleshooting.vue';
import OldVersion from '@/views/gbwaps/OldVersion.vue';
import Blog from '@/views/gbwaps/Blog.vue';
import BlogArticle from '@/views/gbwaps/BlogArticle.vue';
import About from '@/views/gbwaps/About.vue';
import { FAQ_PAGE_FULL_SCHEMA } from '@/data/faq-content';
import { BLOG_POSTS } from '@/data/blog-content';
import { FEATURES_FAQ_SCHEMA } from '@/data/features-content';
import { buildArticleSchema } from '@/utils/article-schema';

/** 占位页通用配置 */
function routeName(path) {
	if (path === '/') return 'gbwaps-home';
	return 'gbwaps' + path.replace(/\//g, '-');
}

function placeholderRoute(path, title, intro, breadcrumbName) {
	return {
		path,
		name: routeName(path),
		component: PagePlaceholder,
		meta: {
			...createPageMeta({ title: `${title} | GBWaps`, path }),
			pageTitle: title,
			pageIntro: intro,
			breadcrumb: breadcrumbName ? [{ name: breadcrumbName }] : [],
		},
	};
}

/**
 * 路由 path 统一为带尾斜杠；不在路由表里注册无斜杠 redirect。
 * 否则 Vue Router 会把 /download/ 误匹配到 { path:'/download', redirect }，
 * router-link 会渲染成空节点（只剩 <!-- -->）。
 * 无斜杠访问由 trailingSlashGuard + 服务端 301 处理。
 */
function buildGbwapsRoutes(rawRoutes) {
	return rawRoutes.map((route) => {
		if (route.redirect) return route;
		return { ...route, path: withTrailingSlash(route.path) };
	});
}

const gbwapsRoutesRaw = [
	{
		path: '/',
		name: 'gbwaps-home',
		component: Home,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp APK Download Latest Version 2026 (Official & Safe) | GBWaps',
				description:
					'Download GB WhatsApp APK latest version 18.80 for Android with updated anti-ban protection, enhanced privacy features, and improved stability. Explore new features and safe usage information for the latest version.',
				keywords:
					'gb whatsapp, gb whatsapp download, gb whatsapp apk, gb whatsapp latest version',
				path: '/',
			}),
			jsonLd: [SOFTWARE_APPLICATION_SCHEMA, FAQ_PAGE_SCHEMA],
		},
	},
	{
		path: '/download',
		name: 'gbwaps-download',
		component: Download,
		meta: {
			...createPageMeta({
				title: 'Download GB WhatsApp APK for Android | Safe Installation | GBWaps',
				description:
					'Download GB WhatsApp APK latest version 2026 for Android with full file details, system requirements, version info, and safety notice.',
				keywords: 'Download GB WhatsApp, GB WhatsApp download, download GB WhatsApp APK',
				path: '/download',
			}),
		},
	},
	{
		path: '/install-gbwhatsapp',
		name: 'gbwaps-install-gbwhatsapp',
		component: InstallGbwhatsapp,
		meta: {
			...createPageMeta({
				title: 'How to Install GB WhatsApp APK on Android | Step-by-Step Guide | GBWaps',
				description:
					'Learn how to install GB WhatsApp APK on Android devices with simple steps, permissions setup, and troubleshooting tips.',
				keywords: 'install GB WhatsApp APK, how to install GBWhatsApp',
				path: '/install-gbwhatsapp',
			}),
			jsonLd: [INSTALL_HOWTO_SCHEMA],
		},
	},
	{
		path: '/gbwhatsapp-update',
		name: 'gbwaps-gbwhatsapp-update',
		component: GbwhatsappUpdate,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp Update Latest Version Guide 2026 | Safe Update Method | GBWaps',
				description:
					'Learn how to safely update GB WhatsApp without losing chats, data, or settings.',
				keywords: 'GB WhatsApp update, update GB WhatsApp, GB WhatsApp new version',
				path: '/gbwhatsapp-update',
			}),
			jsonLd: [UPDATE_HOWTO_SCHEMA],
		},
	},
	{
		path: '/features',
		name: 'gbwaps-features',
		component: Features,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp Features List 2026 | Privacy & Custom Tools | GBWaps',
				description:
					'Explore GB WhatsApp features including privacy tools, custom themes, larger media sharing, dual account, and chat controls vs official WhatsApp.',
				keywords: 'GB WhatsApp features, GB WhatsApp privacy features',
				path: '/features',
			}),
			jsonLd: [FEATURES_FAQ_SCHEMA],
		},
	},
	{
		path: '/anti-ban',
		name: 'gbwaps-anti-ban',
		component: AntiBan,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp Anti Ban Guide 2026 | Avoid Account Ban Tips | GBWaps',
				description:
					'Learn how to reduce ban risk and use GB WhatsApp safely with anti-ban settings and best practices.',
				keywords: 'GB WhatsApp anti ban, GB WhatsApp ban, avoid ban',
				path: '/anti-ban',
			}),
		},
	},
	{
		path: '/faq',
		name: 'gbwaps-faq',
		component: Faq,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp FAQ | Common Questions & Answers 2026 | GBWaps',
				description:
					'Find answers to common questions about GB WhatsApp download, installation, safety, and features.',
				keywords: 'GB WhatsApp FAQ, GB WhatsApp questions',
				path: '/faq',
			}),
			jsonLd: [FAQ_PAGE_FULL_SCHEMA],
		},
	},
	{
		path: '/troubleshooting',
		name: 'gbwaps-troubleshooting',
		component: Troubleshooting,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp Not Working Fix Guide 2026 | Crash & Login Issues | GBWaps',
				description:
					'Fix GB WhatsApp errors including crash, login issues, verification problems, and installation failures.',
				keywords: 'GB WhatsApp not working, GB WhatsApp fix, GB WhatsApp error',
				path: '/troubleshooting',
			}),
		},
	},
	{
		path: '/old-version',
		name: 'gbwaps-old-version',
		component: OldVersion,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp Old Version Download APK | Stable Versions Archive | GBWaps',
				description:
					'Download old and stable versions of GB WhatsApp APK for compatibility and performance reasons.',
				keywords: 'GB WhatsApp old version, GB WhatsApp download old version',
				path: '/old-version',
			}),
		},
	},
	{
		path: '/blog',
		name: 'gbwaps-blog',
		component: Blog,
		meta: {
			...createPageMeta({
				title: 'GB WhatsApp Blog | Tips, Updates & Guides 2026 | GBWaps',
				description:
					'Latest news, tips, guides, and updates about GB WhatsApp APK and features.',
				keywords: 'GB WhatsApp blog, GB WhatsApp tips',
				path: '/blog',
			}),
		},
	},
	{
		path: '/about',
		name: 'gbwaps-about',
		component: About,
		meta: {
			...createPageMeta({
				title: 'About GBWaps | Independent GB WhatsApp Guides for Android',
				description:
					'Learn about GBWaps — an independent site with GB WhatsApp download guides, install tutorials, updates, features, and troubleshooting for Android users.',
				keywords: 'about GBWaps, GB WhatsApp guide, GB WhatsApp help',
				path: '/about',
			}),
		},
	},
	...BLOG_POSTS.map((post) => ({
		path: `/blog/${post.slug}`,
		name: `gbwaps-blog-${post.slug}`,
		component: BlogArticle,
		props: { slug: post.slug },
		meta: {
			...createPageMeta({
				title: post.meta.title,
				description: post.meta.description,
				keywords: post.meta.keywords,
				path: `/blog/${post.slug}`,
			}),
			jsonLd: [buildArticleSchema(post)],
		},
	})),
	placeholderRoute('/contact-us', 'Contact Us', 'Get in touch — Phase 8.', 'Contact'),
	placeholderRoute('/privacy-policy', 'Privacy Policy', 'Privacy policy — Phase 8.', 'Privacy'),
	placeholderRoute('/terms-of-service', 'Terms of Service', 'Terms of service — Phase 8.', 'Terms'),
	placeholderRoute('/disclaimer', 'Disclaimer', 'Disclaimer — Phase 8.', 'Disclaimer'),
];

export const gbwapsRoutes = buildGbwapsRoutes(gbwapsRoutesRaw);
